import React , {useState} from 'react'
import { MenuItems } from './MenuItems'
import './header.css'
import {Link as Linkscroll} from 'react-scroll'
import DarkMode from './DarkMode'
import Flag from './sa.svg'
import {Link} from 'react-router-dom'


const Header = () => {

    const [clicked,setClicked] = useState(false)
    const [navbar,setNavbar] = useState(false) 

    const handleClick = ()=>{
        setClicked(!clicked)
    }
    const changeBackground = ()=>{
        if(window.scrollY >= 50){
            setNavbar(true)
        }else{
            setNavbar(false)
        }
    }
    window.addEventListener('scroll',changeBackground)

    
    return (
        <>
        <header className={navbar ? 'bg-header header': 'header'} id="header">
            <nav className="nav container">
                <Linkscroll to="home" href='#' className="nav__logo">
                    ElQaNaS
                </Linkscroll>

                <div className={clicked ? 'nav__menu show-menu' : 'nav__menu'}>
                    <ul className='nav__list grid'>
                        {
                            MenuItems.map((item,index)=>{
                                return(
                                    <li className={item.cName} key={index}>
                                        <Linkscroll activeClass={item.ActiveLink} href='#' to={item.url} spy={true} smooth={false} offset={-70} duration={500} className={item.cNameLink} onClick={handleClick}>
                                            <i className={item.icon}></i> {item.title}
                                        </Linkscroll>
                                    </li>
                                )
                            })
                        }
                    </ul>
                        {/* <!-- Close button --> */}
                    <div className="nav__close" onClick={handleClick}>
                        <i className={clicked ? 'ri-close-line' : ''}></i>
                    </div>
                </div>

                    <div className="nav__buttons">
                        {/* <!-- Theme Change Button --> */}
                        <DarkMode />

                        <div className="nav__lang-eng">
                            <Link to='/'><img src={Flag} alt="flag" /></Link>
                        </div>

                        {/* <!-- Toggle Button --> */}
                        <div className="nav__toggle" onClick={handleClick}>
                        <i className={clicked ? '' : 'ri-menu-4-line'}></i>
                        </div>
                    </div>

            </nav>
        </header>
        </>
    )
}

export default Header